module.exports = __webpack_public_path__ + "img/CompanyoperationproofaddressShili.46c25a22.jpg";